import { convertDimensionFromIdToName, convertDimensionFromNameToId, deleteManyColumnOptionStates, deleteManyColumnTemplates, isDimensionId, isDimensionName, updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../../helpers";
import { DatapointKind } from "../../types";
import { ColumnTypesToChartSelectValueFormatKind } from "components/widgets/grid/grid-column-types";
import { SerieTypeEnum } from "hooks/widget-data/datapoints-api/visitors/custom/highcharts-timeseries/types";
import { selectEditorPreviewWidgetComponentProps } from "store/widget-workshop/draft-selectors";
import { defaultMeasureDimensionByEntity } from "store/widget-workshop/initialState";
import { getDatapointRequestElementFromColumnOptionState, getIdDimensionDatapointName } from "store/widget-workshop/utils";
export const updateMeasureForTimeseries = (state, componentProps, changeCustomVisitors = true) => {
    const map = [];
    const series = [];
    state.editor.settings?.data?.columns?.options?.sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0)).forEach((e, i) => {
        let yAxis = map.findIndex((f) => f === ColumnTypesToChartSelectValueFormatKind[e.type || ""]);
        if (yAxis === -1) {
            yAxis = map.length;
            map.push(ColumnTypesToChartSelectValueFormatKind[e.type || ""]);
        }
        series.push({
            id: e.id,
            name: e.name,
            order: i,
            type: e.highchartsDisplayType || "line",
            valueFormat: ColumnTypesToChartSelectValueFormatKind[e.type || ""],
            yAxis
        });
    });
    if (changeCustomVisitors) {
        componentProps.pipelineParameter.customVisitorsReducer = [
            {
                arguments: {
                    series: [...series]
                },
                method: "highchartsTimeSeriesCreation"
            },
            {
                method: "highchartsTimeSeries"
            }
        ];
    }
    const compProps = selectEditorPreviewWidgetComponentProps(state);
    const metadata = state.editor.preview?.widget?.metadata;
    let datapoint = {};
    if (metadata) {
        datapoint = defaultMeasureDimensionByEntity[metadata?.entityType[0]];
    }
    if (compProps.datapointParams[0].dimensions.length === 0 && datapoint) {
        compProps.datapointParams[0].dimensions = datapoint?.dimensions;
        compProps.userSettings.chartTypeAvailable = undefined;
        compProps.pipelineParameter.compositeObjectBuilder.measures = compProps.pipelineParameter.compositeObjectBuilder.measures
            .filter((x) => compProps.columnsTemplate.columns.map((y) => y.field).includes(x));
    }
};
const removeManyDatapointRequests = (state, names) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (!componentProps || componentProps?.datapointParams?.length < 1) {
        return;
    }
    if (componentProps.datapointParams[0].measures) {
        componentProps.datapointParams[0].measures = componentProps.datapointParams[0].measures.filter((c) => names.findIndex((name) => c.name === name) === -1);
    }
    if (componentProps.datapointParams[0].dimensions) {
        componentProps.datapointParams[0].dimensions = componentProps.datapointParams[0].dimensions.filter((c) => names.findIndex((name) => c.name === name) === -1);
    }
};
export const updateTimeSeries = (componentProps, datapointRequestElement) => {
    if (!datapointRequestElement) {
        return;
    }
    if (!componentProps.datapointParams || componentProps.datapointParams.length < 1 ||
        (!componentProps.datapointParams[0].measures && !componentProps.datapointParams[0].dimensions)) {
        componentProps.datapointParams = [{ dimensions: [], measures: [] }];
    }
    const datapoints = componentProps.datapointParams[0].dimensions;
    // Clear the datapoints array
    datapoints.length = 0;
    // Add the new datapoint
    datapoints.push(datapointRequestElement);
};
const addOrUpdateDimension = (state, action, componentProps) => {
    componentProps.userSettings = {
        ...componentProps.userSettings || {},
        chartTypeAvailable: "TimeSeriesCharts"
    };
    updateOrAddDatapointRequest(state, { ...action.payload, history: true });
    const compProps = selectEditorPreviewWidgetComponentProps(state);
    if (compProps) {
        updateTimeSeries(compProps, getDatapointRequestElementFromColumnOptionState({ ...action.payload, history: true }));
    }
    const isIdNameCase = action.payload.datapoint && isDimensionName(action.payload.datapoint);
    if (isIdNameCase) {
        const newId = getIdDimensionDatapointName(action.payload.id);
        const IdDatapointInsteadOfName = action.payload.datapoint === undefined ? action.payload.datapoint : convertDimensionFromNameToId(action.payload.datapoint);
        removeManyDatapointRequests(state, [action.payload.id]);
        updateOrAddDatapointRequest(state, { ...action.payload, datapoint: IdDatapointInsteadOfName, id: newId });
        updateOrAddDatapointRequest(state, { ...action.payload, datapointKind: DatapointKind.Measure });
    }
    updateMeasureForTimeseries(state, componentProps);
    if (componentProps.pipelineParameter) {
        componentProps.pipelineParameter.customVisitorsReducer = [
            {
                arguments: {
                    seriesDiscovery: {
                        dimensionDatapoint: componentProps.pipelineParameter?.compositeObjectBuilder?.measures?.[0],
                        measureDatapoint: componentProps.pipelineParameter?.compositeObjectBuilder?.measures[1]
                    }
                },
                method: "highchartsTimeSeriesCreation"
            },
            {
                method: "highchartsTimeSeries"
            }
        ];
    }
};
const handleColumnsForTimeseries = (state, action, componentProps) => {
    const builder = componentProps.pipelineParameter?.compositeObjectBuilder ?? { measures: [] };
    // Get the name and standard datapoint of the first and only dimension in datapointParams
    const dimensionName = componentProps?.datapointParams?.[0]?.dimensions?.[0]?.name;
    const datapointName = componentProps?.datapointParams?.[0]?.dimensions?.[0]?.standardDatapoint ?? "";
    if (dimensionName && dimensionName?.length) {
        // Prepare a list of datapoints to delete
        const datapointsToDelete = [dimensionName, getIdDimensionDatapointName(dimensionName)];
        // Remove the dimension name from the measures in the builder, both dimensions and measures are in builder.measures
        builder.measures = builder.measures.filter((m) => m !== dimensionName);
        if (isDimensionId(datapointName)) {
            // If the datapoint name is an ID, find the corresponding measure name and remove it from the measures and columns
            const measureName = componentProps?.datapointParams?.[0]?.measures?.find((m) => m.standardDatapoint === convertDimensionFromIdToName(datapointName))?.name ?? "";
            removeManyDatapointRequests(state, [measureName]);
            builder.measures = builder.measures.filter((m) => m !== measureName);
            datapointsToDelete.push(measureName);
        }
        // Delete the column templates and option states for the datapoints to delete
        deleteManyColumnTemplates(state, datapointsToDelete);
        deleteManyColumnOptionStates(state, datapointsToDelete);
        // Add the new dimension ID to the beginning of the measures array
        builder.measures.unshift(action.payload.id);
    }
};
export const addOrUpdateDatapointForTimeseries = (state, action, componentProps) => {
    const newColumnOption = updateOrAddColumnOptionState(state, action.payload);
    if (newColumnOption) {
        updateOrAddColumnTemplate(state, newColumnOption);
    }
    if (action.payload.datapointKind === DatapointKind.Measure) {
        updateOrAddDatapointRequest(state, { ...action.payload, history: true });
        const measures = componentProps.pipelineParameter.compositeObjectBuilder.measures;
        const doesMeasureExist = measures.includes(action.payload.id);
        if (measures && !doesMeasureExist) {
            measures.push(action.payload.id);
        }
        const isInDimensionMode = componentProps.pipelineParameter?.customVisitorsReducer?.[0]?.arguments?.seriesDiscovery;
        updateMeasureForTimeseries(state, componentProps, !isInDimensionMode);
    }
    if (action.payload.datapointKind === DatapointKind.Dimension) {
        // Set the chart series type to column
        componentProps.chartSeriesTypes = [SerieTypeEnum.column];
        handleColumnsForTimeseries(state, action, componentProps);
        addOrUpdateDimension(state, action, componentProps);
    }
};
